import { Link } from "@/components/Link";
import type { TestSpecDetail } from "../../types";
import { useAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TabLayout } from "../TabLayout";

export function TestSpecOrgsTable({
  testSpec,
}: {
  testSpec: NonNullable<TestSpecDetail>;
}) {
  const orgs = testSpec.orgsTestSpecs || [];

  const { options } = useAdminGridOptions(
    orgs,
    [
      {
        field: "org.name",
        cellRenderer: (params) => (
          <Link to="/admin/clients/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          id: params.data.org.id,
          name: params.data.org.name,
        }),
        headerName: "Client",
      },
      {
        colId: "price",
        headerName: "Price",
        type: "numericColumn",

        valueFormatter: (params) => `$${params.value.toFixed(2)}`,

        valueGetter: (params) => {
          return params.data && params.data.price !== null
            ? params.data.price
            : (testSpec.price ?? 0);
        },
      },
    ],
    { sideBar: undefined },
  );

  return (
    <TabLayout
      description="The following clients are allowed to select this panel during order
    entry"
    >
      <div className="flex h-96">
        <AdminGrid {...options} />
      </div>
    </TabLayout>
  );
}
